/**
 * Bakery > Dough > *
 */
export const bakeryDough = [/^A_FH_001_001(_[0-9]{3}){0,1}$/];

/**
 * Bakery > Filling > *
 */
export const bakeryFilling = [/^A_FH_001_002(_[0-9]{3}){0,1}$/];

/**
 * Bakery > Bread making > *
 */
export const bakeryBreadMaking = [/^A_FH_001_003(_[0-9]{3}){0,1}$/];

/**
 * Beverage > *
 */
export const beverages = [/^A_FH_005(_[0-9]{3}){0,2}$/];

/**
 * Cereals > *
 */
export const cereals = [/^A_FH_011(_[0-9]{3}){0,2}$/];

/**
 * Confectionary > *
 */
export const confectionary = [/^A_FH_007(_[0-9]{3}){0,2}$/];

/**
 * Convenience > *
 */
export const convenience = [/^A_FH_003(_[0-9]{3}){0,2}$/];

/**
 * Dairy, dairy alternatives, fermented milk products, ice cream > *
 */
export const dairy = [/^A_FH_002(_[0-9]{3}){0,2}$/];

/**
 * Desserts > *
 */
export const desserts = [/^A_FH_006(_[0-9]{3}){0,2}$/];

/**
 * Flavour blends > *
 */
export const flavourBlends = [/^A_FH_010(_[0-9]{3}){0,2}$/];

/**
 * Fruit, Vegetables, Jam, Fillings > *
 */
export const fruitJam = [/^A_FH_009(_[0-9]{3}){0,2}$/];

/**
 * Gravies, marinates and meals > *
 */
export const graviesMarinatesMeals = [/^A_FH_015(_[0-9]{3}){0,2}$/];

/**
 * Meat, Fish, Poultry > *
 */
export const meatFish = [/^A_FH_012(_[0-9]{3}){0,2}$/];

/**
 * Oils, Fats, Spreads > *
 */
export const oilsFatsSpreads = [/^A_FH_013(_[0-9]{3}){0,2}$/];

/**
 * Plant-based foods > *
 */
export const plantBasedFoods = [/^A_FH_014(_[0-9]{3}){0,2}$/];

/**
 * Soups, Sauces, Seasoning, Dressings > *
 */
export const soupsSaucesSeasonings = [/^A_FH_008(_[0-9]{3}){0,2}$/];
